<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle
                :title="config.BRIEF_RULES_TITLE"
                :description="config.BRIEF_RULES_DESCRIPTION"
            />
            <BriefRuleset type="do" :title="config.BRIEF_RULES_DO" :rules="briefRules"/>
            <BriefRuleset type="dont" :title="config.BRIEF_RULES_DONT" :rules="briefRules"/>
            <SectionActions>
                <Button v-if="!smartUploader" :color="config.COLOR_PRIMARY" :disabled="disabled" @click="onCTA">
                    {{ config.BRIEF_RULES_CTA }}
                </Button>
                <a v-else :href="smartUploaderUrl" target="_blank" class="link-btn">
                    {{ config.BRIEF_RULES_CTA }}
                </a>
            </SectionActions>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer, ProjectConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { BriefRuleset, SectionTitle, SectionActions } from '../../components/shared';
import { buildSmartUploaderUrl } from '../../utils';

export default {
    name: 'BriefRules',
    components: {
        Page, SectionTitle, SectionActions, BriefRuleset,
    },
    mixins: [SolutionConsumer, ProjectConsumer],
    props: {
        next: {
            type: String,
            required: true,
        },
        product: {
            type: Object,
            default: null,
        },
        captureFrontUrl: {
            type: String,
            default: null,
        },
        /**
         * Whether to disable the CTA button
         */
        disabled: {
            type: [Boolean, String],
            default: false,
        },
    },
    data () {
        return {
            smartUploader: this.$store.state.solution.smartUploader,
        };
    },
    computed: {
        smartUploaderUrl () {
            return buildSmartUploaderUrl({
                smartUploaderConfig: this.smartUploader ? this.smartUploader.config : null,
                captureFrontUrl: this.captureFrontUrl,
                ...(this.product ? { product: this.product } : {}),
                ...(this.product ? { order: this.product.order } : {}),
            });
        },
    },
    methods: {
        onCTA () {
            if (this.showUploadInformation && this.shouldAskInformation) {
                this.$router.push({ name: 'deposit.information' });
            } else {
                this.$router.push({ name: this.next });
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px 20px);
}
</style>
